module.exports = __webpack_public_path__ + "static/img/icon-under-maintenance.57db837c.png";